import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.data("homeHero", () => ({
    introDone: false,
    init() {
        if (!this.$refs.introVideo) {
            document.body.classList.add("introDone");
            const event = new CustomEvent("introDone");
            window.dispatchEvent(event);
        }
    },
    setCookie(days = 365) {
        let d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = "introDone" + "=" + !this.show + ";" + expires + ";path=/;secure";
    },
    introAnimation() {
        setTimeout(() => {
            // this.$refs.introVideo.style.opacity = 0;
            this.$refs.loopVideo.play();
            this.$refs.loopVideoMobile?.play();
        }, (this.$refs.introVideo.duration - 0.5) * 1000);
        setTimeout(() => {
            document.body.classList.add("introDone");
            this.setCookie();
        }, (this.$refs.introVideo.duration - 0.5) * 1000);
        setTimeout(() => {
            this.introDone = true;

            const event = new CustomEvent("introDone");
            window.dispatchEvent(event);
        }, (this.$refs.introVideo.duration + 2) * 1000);
    },
}));
